var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02734 11.9453L7.42578 12.5469C7.15234 12.793 6.74219 12.793 6.49609 12.5469L1.19141 7.21484C0.917969 6.96875 0.917969 6.55859 1.19141 6.3125L6.49609 0.980469C6.74219 0.734375 7.17969 0.734375 7.42578 0.980469L8.02734 1.58203C8.30078 1.85547 8.27344 2.26562 8.02734 2.53906L4.71875 5.65625H12.5938C12.9492 5.65625 13.25 5.95703 13.25 6.3125V7.1875C13.25 7.57031 12.9492 7.84375 12.5938 7.84375H4.71875L8.02734 10.9883C8.27344 11.2617 8.30078 11.6719 8.02734 11.9453Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b0cd04c69e6534571cd07dd5bf7f2712.svg";
export { ForwardRef as ReactComponent };